import type { SVGProps } from 'react';

const SvgArrowButtonRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M16 0c8.84 0 16 7.16 16 16s-7.16 16-16 16S0 24.84 0 16 7.16 0 16 0Z"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.33 16h9.33M16 11.33 20.67 16 16 20.67"
    />
  </svg>
);

export default SvgArrowButtonRight;
